export default __webpack_public_path__ + "static/media/fi-rr-angle-small-down.9f5a3ec4.svg";